// React for Website

import React from "react";
import { useNavigate, useParams } from "react-router-dom";
//outsource
import { Row, Col, List, Space, Button, Popconfirm, message } from "antd";
import { AiFillGift } from "react-icons/ai";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
//components

//redux
import { useDispatch } from "react-redux";

const VoucherCard = ({ data, setOpen, setSelected }) => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id || "";
  const code = data?.code || "";
  const price = data?.balance - data?.spent || "";
  const email = data?.senderEmail || "";
  const phone = data?.senderPhone || "N/A";
  const balance = data?.balance || 0;
  const createAt = data?.createAt
    ? moment(data?.createAt?.toDate()).format("DD MMM YYYY hh:mm A")
    : "";

  const iconColor = renderIconColor(data);
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION -----------------------
  const handleDetail = () => {
    setOpen(true);
    setSelected(data);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBodyCard = () => {
    return (
      <div>
        <Space style={{ alignItems: "center" }} size="large">
          <div style={{ fontSize: 20 }}>{code}</div>
          <span>
            <h2 style={{ fontWeight: "bold", margin: 0 }}>${balance}</h2>
          </span>
          <span>(Purchased On {createAt})</span>
        </Space>
        <Space
          style={{ alignItems: "center", fontWeight: "normal" }}
          size="large"
        >
          <div>
            Email: <b>{email}</b>
          </div>
          <div>
            Mobile: <b>{phone}</b>
          </div>
          <div>
            Balance:{" "}
            <b style={{ color: balance === 0 ? "red" : "black" }}>${price}</b>
          </div>
        </Space>
      </div>
    );
  };

  const renderButtonGroup = () => {
    return (
      <Space>
        <Button
          icon={<InfoCircleOutlined />}
          onClick={handleDetail}
          type="primary"
        >
          Details
        </Button>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <List.Item>
      <Row
        gutter={[20]}
        style={{
          width: "100%",
          minHeight: 70,
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        <Col align="center" span={2}>
          <AiFillGift style={{ color: iconColor }} size={50} />
        </Col>
        <Col span={18}>{renderBodyCard()}</Col>
        <Col align="right" span={4}>
          {renderButtonGroup()}
        </Col>
      </Row>
    </List.Item>
  );
};

export default VoucherCard;

const renderIconColor = (item) => {
  switch (item?.source) {
    case "website":
      return "blue";

    case "admin":
      return "purple";
    case "pos":
      return "#65e142";

    default:
      return "black";
  }
};
